import React from "react";
import Checkbox from "@material-ui/core/Checkbox";

class CheckboxEditor extends React.Component{
    constructor(props){
        super(props);
        this.state ={
            checked: Boolean(props.data)
        }
    }

    getValue = () => {
        return Boolean(this.state.checked);
    }

    isPopup = () => {
        return false;
    }

    handleChange = (event) => {
        this.setState({
            checked: event.target.checked
        });
    }

    // Gets called once before editing starts, to give editor a chance to
    // cancel the editing before it even starts.
    isCancelBeforeStart(){
        const { colDef } = this.props.column || {};
        return colDef && colDef.type === "isCancelBeforeStart";
    }

    render(){
        return(
            <Checkbox
                classes={{
                    root: "editCheckbox"
                }}
                checked={this.state.checked}
                onChange={this.handleChange}
                color="primary"
            />
        )
    }
}

export default CheckboxEditor;